function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,130.000000) scale(0.100000,-0.100000)",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M465 1286 c-315 -73 -465 -278 -465 -636 0 -272 97 -473 275 -567 120 -63 191 -78 375 -78 145 0 174 3 240 23 208 65 317 174 382 382 20 66 23 95 23 240 0 145 -3 174 -23 240 -65 206 -173 315 -377 380 -89 29 -335 38 -430 16z m383 -297 l152 -80 0 -158 c0 -220 -29 -309 -138 -423 -57 -60 -173 -128 -217 -128 -44 0 -160 68 -217 128 -111 116 -140 207 -136 426 l3 158 172 89 c201 103 158 105 381 -12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M487 959 l-157 -79 0 -120 c0 -179 24 -265 102 -368 44 -59 141 -128 194 -138 80 -15 226 98 282 218 41 86 52 149 52 288 l0 120 -158 79 -157 79 -158 -79z m275 -96 l109 -58 -3 -110 c-3 -85 -9 -121 -25 -156 -40 -89 -134 -169 -198 -169 -64 0 -158 80 -198 169 -16 35 -22 71 -25 156 l-3 110 108 57 c59 31 112 57 117 58 4 0 58 -26 118 -57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605 761 c-125 -58 -83 -251 55 -251 31 0 90 24 90 37 0 4 -7 14 -15 23 -12 13 -27 16 -59 13 -31 -4 -47 -1 -59 12 -23 22 -22 78 1 98 21 19 67 23 77 6 5 -7 16 -2 31 12 29 27 29 31 5 46 -36 22 -84 24 -126 4z"
}));

var SvgInfohub = function SvgInfohub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130.000000pt",
    height: "130.000000pt",
    viewBox: "0 0 130.000000 130.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfohub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infohub.ddd0fd46.svg";
export { ForwardRef as ReactComponent };